<template>
  <div class="eatCode">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">用餐码</span>
    </div>
    <van-swipe class="my-swipe" :autoplay="0" indicator-color="white">
      <van-swipe-item v-for="(item, index) in info" :key="index">
        <div class="swipeArea">
          <div class="content">
            <div class="head">
              <div class="left">
                <div>
                  {{ item.personName }}
                  <van-tag :color="filterColor(item.mealStatus)" text-color="#FFFFFF">
                    {{ zh.zhCN.mealStatus[item.mealStatus] }}
                  </van-tag>
                </div>
                <div class="no">
                  {{ mealInfo.mealRuleName }}{{ item.bookingSerial }}
                </div>
                <div class="no">
                  {{ mealInfo.bookingDate }}
                </div>
<!--                <div>{{ item.mealRuleName }}</div>-->
              </div>
              <div class="right">
                <div>
                  {{ index + 1 }}/{{ info.length }}
                </div>
<!--                <div class="no">-->
<!--                  {{ item.bookingSerial }}-->
<!--                </div>-->
              </div>
            </div>
            <img :src="`${baseURL}/wechat/qr/create?content=${encodeURIComponent(item.bookingQr)}&timestamp=${new Date().getTime()}`" alt="" mode="widthFix">
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { eatInfo } from '@/api/user';
import config from '@/common/config';
export default {
  name: 'EatCode',
  data() {
    return {
      baseURL:
          process.env.NODE_ENV === 'development'
            ? config.baseUrl.dev
            : config.baseUrl.pro,
      info: [],
      mealInfo: {}
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      eatInfo({ id: this.$route.query.id }).then(response => {
        this.info = response.data.mealCodes;
        this.mealInfo = response.data;
      });
    },
    filterColor(e) {
      const list = {
        EXPIRE: '#FF6565',
        CANCEL: '#43425D',
        UNUSED: '#4AD991',
        USED: '#43425D'
      };
      return list[e];
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}

/deep/.van-swipe__indicator {
  border: 1px solid #1989fa;
}

  .eatCode {
    .swipeArea {
      .change_val(padding-bottom, 50);
      .content {
        .change_val(margin, 10);
        background-color: #FFFFFF;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
        }

        .head {
          display: flex;
          justify-content: space-between;
          .change_val(padding, 20);
          .left {
            .change_val(font-size, 28);
            .no {
              .change_val(font-size, 20);
              color: #3B86FF;
            }
          }

          .right {
            text-align: right;
            //.no {
            //  color: gray;
            //}
          }
        }
      }

    }

  }
</style>
